import React from 'react';
import 'twin.macro';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/outline';
import { CahierJournalButtonLink } from 'containers/CahierJournal/CahierJournalButtonLink';
import { getNextDateUrl } from 'containers/CahierJournal/Toolbar/getNextDateUrl';
import { CahierJournalView } from 'containers/CahierJournal/types';
import { getPreviousDateUrl } from 'containers/CahierJournal/Toolbar/getPreviousDateUrl';
import {
  getNextDayBasedOnViewAndWorkingDays,
  getPreviousDayBasedOnViewAndWorkingDays,
} from 'utils/time';

interface Props {
  minimal?: boolean;
  view: CahierJournalView;
  onChange?: (v: Date) => void;
  workingDays: number[];
  date: Date;
  iconSize?: 'sm' | 'md' | 'lg' | 'xl';
}

function Before(props: Props) {
  const { iconSize, minimal, view, date, workingDays, onChange } = props;

  return (
    <CahierJournalButtonLink
      minimal={minimal}
      aria-label="Aller à la semaine précédente"
      to={getPreviousDateUrl(view, date, workingDays)}
      onClick={
        onChange
          ? () => {
              onChange(
                getPreviousDayBasedOnViewAndWorkingDays(
                  view,
                  date,
                  workingDays,
                ),
              );
            }
          : undefined
      }
      icon={ChevronLeftIcon}
      iconSize={iconSize}
    />
  );
}

function After(props: Props) {
  const { iconSize, minimal, view, date, workingDays, onChange } = props;
  return (
    <CahierJournalButtonLink
      minimal={minimal}
      aria-label="Aller à la semaine suivante"
      to={getNextDateUrl(view, date, workingDays)}
      onClick={
        onChange
          ? () => {
              onChange(
                getNextDayBasedOnViewAndWorkingDays(view, date, workingDays),
              );
            }
          : undefined
      }
      icon={ChevronRightIcon}
      iconSize={iconSize}
    />
  );
}

export function ArrowDateNavigator() {
  return null;
}

ArrowDateNavigator.Before = Before;
ArrowDateNavigator.After = After;
